import { render, staticRenderFns } from "./block.vue?vue&type=template&id=2266d535&scoped=true"
import script from "./block.vue?vue&type=script&setup=true&lang=js"
export * from "./block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./block.vue?vue&type=style&index=0&id=2266d535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266d535",
  null
  
)

export default component.exports